(function ($) {
  'use strict';

  function initCarousel($pane) {
    var $carousel = $pane.find('[data-xplora-product-carousel]');

    if (!$carousel.length || typeof $.fn.slick !== 'function') {
      return;
    }

    if (!$carousel.hasClass('slick-initialized')) {
      $carousel.slick();
    } else {
      $carousel.slick('setPosition');
    }

    $carousel.slick('slickPlay');
  }

  function activateTab($section, $tab) {
    var $tabs = $section.find('[data-xplora-shop-tab]');
    var $panes = $section.find('.tab-content > .tab-pane');
    var target = $tab.attr('href');
    var $pane = $section.find(target);

    if (typeof $.fn.slick === 'function') {
      $panes.find('[data-xplora-product-carousel].slick-initialized').slick('slickPause');
    }
    $tabs.removeClass('active').attr('aria-selected', 'false');
    $panes.removeClass('active show');

    $tab.addClass('active').attr('aria-selected', 'true');
    $pane.addClass('active show');
    initCarousel($pane);
  }

  function initSection(section) {
    var $section = $(section);
    var $tabs = $section.find('[data-xplora-shop-tab]');

    if ($section.data('xplora-shop-now-ready') || !$tabs.length) {
      return;
    }

    $section.data('xplora-shop-now-ready', true);
    $tabs.on('click.xploraShopNow', function (event) {
      event.preventDefault();
      activateTab($section, $(this));
    });

    activateTab($section, $tabs.filter('.active').first().length ? $tabs.filter('.active').first() : $tabs.first());
  }

  function initAll(scope) {
    var $scope = $(scope || document);
    var $sections = $scope.filter('[data-xplora-shop-now]').add($scope.find('[data-xplora-shop-now]'));

    $sections.each(function () {
      initSection(this);
    });
  }

  $(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})(window.jQuery);
